import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';

export class ErrorBoundary extends React.Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log('error cateched :', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container
          fluid={true}
          style={{
            minHeight: '100vh',
            position: 'relative',
          }}
        >
          <Row style={{ marginTop: '40px' }} className="text-center">
            <Col sm="12" md={{ size: 4, offset: 4 }}>
              <h1 style={{ fontSize: '18px' }}>An Error Occurred</h1>
              <div>
                <p>
                  There has been an error. It’s been reported to the site administrators via email
                  and should be fixed shortly. Thanks for your patience.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="text-center">
            <Col sm="12">
              <Button
                color="primary"
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                Back to Home
              </Button>
            </Col>
          </Row>
        </Container>
      );
    }
    return this.props.children;
  }
}
